import { useState, useMemo, useEffect } from 'react';
import ModalWrapper from '../ModalWrapper';
import { CommonFooter, InputBox } from '../FormComponent';
import { getDisplayFileName, splitFileName } from './helpers';
import FileTypeChip from './FileTypeChip';
import styles from '../../styles/assetsManagement/filesManager.module.scss';

const EditFileModal = ({ file, onSave, onClose }) => {
  const { namePart: initialName, extension: fixedExtension } = useMemo(
    () => splitFileName(getDisplayFileName(file) || ''),
    [file],
  );
  const [namePart, setNamePart] = useState(initialName);
  const [description, setDescription] = useState(file.fileDescription || '');
  const [nameError, setNameError] = useState('');

  useEffect(() => {
    setNamePart(initialName);
    setDescription(file.fileDescription || '');
    setNameError('');
  }, [file?.id, initialName, file?.fileDescription]);

  const handleSave = () => {
    const trimmed = namePart.trim();
    if (!trimmed) { setNameError('File name is required'); return; }
    if (trimmed.length > 200) { setNameError('Max 200 characters'); return; }
    // Send name only; extension is from file_metadata.mimeType on the backend
    onSave({ fileName: trimmed, fileDescription: description.trim() || null });
  };

  const buttons = [
    { label: 'Cancel', variant: 'outline', className: 'primary', onClick: onClose },
    {
      label: 'Save',
      variant: 'primary',
      className: 'white bg-blue600',
      onClick: handleSave,
      disabled: !namePart.trim(),
    },
  ];

  return (
    <ModalWrapper isOpen onClose={onClose} title="Edit File" size="small" footer={<CommonFooter buttons={buttons} />}>
      <div className={styles.folderFormBody}>
        <InputBox
          label="File name"
          value={namePart}
          onChange={(e) => { setNamePart(e.target.value); if (nameError) setNameError(''); }}
          placeholder={fixedExtension ? 'e.g. Sprint 1 execution report' : 'e.g. report'}
          maxLength={200}
          error={!!nameError}
          helperText={nameError}
          required
          endIcon={fixedExtension ? <FileTypeChip mimeType={file.fileType} fileName={`.${fixedExtension}`} /> : undefined}
          className={fixedExtension ? styles.fileNameInputWithChip : undefined}
        />
        <InputBox
          label="Description (optional)"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          placeholder="Describe this file…"
          multiline
          rows={2}
          maxLength={500}
        />
      </div>
    </ModalWrapper>
  );
};

export default EditFileModal;
